import type { SerializedStyles } from '@emotion/react';
import { Button, Flex, TextInput } from '@inflearn/ds-react-next';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ERROR_MESSAGE } from '../../validators/constants';
import ValidationMessage from './ValidationMessage';
import { VerificationNotice } from './VerificationNotice';

type VerificationCodeForm = {
  phone: string;
  verifyCode: string;
  countryCode: string;
};

export type VerificationCodeInputProps = {
  onClickCompletes: (
    data: {
      /**
       * 휴대폰 번호
       */
      phone: string;
      /**
       * 국가 코드
       */
      countryCode: string;
      /**
       * 인증 코드
       */
      verifyCode: string;
    },
    options?: { onError: (error: unknown) => void },
  ) => void;
  styleForm?: SerializedStyles;
};

const VerificationCodeInput = ({ onClickCompletes, styleForm }: VerificationCodeInputProps) => {
  const formContext = useFormContext<VerificationCodeForm>();
  const [isCodeNotMatched, setIsCodeNotMatched] = useState(false);

  const { t } = useTranslation();

  const handleClickComplete = (value: VerificationCodeForm) => {
    onClickCompletes(value, {
      onError: () => {
        setIsCodeNotMatched(true);
      },
    });
  };

  return (
    <>
      <VerificationNotice />
      <Flex
        component="form"
        gap={8}
        w="100%"
        styles={{
          root: styleForm,
        }}
        onSubmit={formContext.handleSubmit(handleClickComplete)}
      >
        <TextInput
          {...formContext.register('verifyCode')}
          onInput={() => setIsCodeNotMatched(false)}
          type="tel"
          size="md"
          placeholder={t('인증번호 입력')}
          error={
            isCodeNotMatched && <ValidationMessage message={ERROR_MESSAGE.VERIFICATION_CODE()} />
          }
          w="100%"
        />
        <Button variant="default" size="md" miw={127} type="submit">
          {t('인증')}
        </Button>
      </Flex>
    </>
  );
};

export default VerificationCodeInput;
